
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-x-stream-demo-default-protocol","docs-x-sdk-x-stream-demo-custom-protocol"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.en-US.md?type=demo')
};